// removed by extract-text-webpack-plugin
module.exports = {"mainContainer":"CoreLayout__mainContainer___165Y4"};


//////////////////
// WEBPACK FOOTER
// ./src/layouts/CoreLayout/CoreLayout.css
// module id = 1110
// module chunks = 56